module.exports ={
    wallet: ['多币种钱包','Multi-Currency'],
    walletDetail: ['多币种钱包余额明细','multi-currency wallet balance details'],
    subMerchant: ['下级商户','sub-Merchant'],
    transactionManage: ['国内交易管理','domestic trans'],
    recharge: ['境内充值明细','domestic recharge'],
    overseasRecharge: ['境外充值明细','overseas recharge details'],
    withdrawal: ['提现明细','withdrawal details'],
    gateway: ['网关支付交易明细','gateway payment tran'],
    authentication: ['鉴权交易明细','authentication trans'],
    payForAnother: ['代付交易明细','payment-on-behalf trans'],
    scanPay: ['扫码支付交易明细','QR code payment trans'],
    refund: ['退款订单明细','refund order details'],
    fastPayment: ['快捷支付交易明细','quick payment trans'],
    commitCustom: ['海关推单明细','customs declaration submission'],
    specialFast: ['订单推送明细','order push'],
    feeManage: ['手续费管理','Fee Mgt'],
    feeDetail: ['手续费明细','fee details'],
    feeReconciliation: ['手续费对账','fee reconciliation'],
    purchasePayment: ['购付汇','Purchase&Pmt'],
    purchasePaymentDetail: ['购付汇 - 批次详情','purchase&pmt-batch'],
    purchasePaymentOrder: ['购付汇 - 订单明细','purchase&pmt-order'],
    initiate: ['发起购付汇','init.purchase&payment'],
    addPayee: ['添加收款人','add payee'],
    payee: ['收款人管理','payee mgt'],
    receivingSettlement: ['收结汇','Coll&Settle'],
    receivingSettlementOrder: ['收结汇订单库','coll&settle ord'],
    receivingSettlementBatch: ['收结汇订单库批次','coll&settle ord batch'],
    receivingSettlementDetail: ['收结汇批次详情','coll&settle batch details'],
    receivingSettlementInitiate: ['发起收结汇','init coll&settle'],
    receivingSettlementIssued: ['查看下发','view disb'],
    overseasCollection: ['海外收款','Overseas Coll'],
    overseasCollectionInitiate: ['发起海外收款','init ovrseas coll'],
    recepitDistribute: ['结汇下发','Settlement&Disb'],
    recepitDistributeDetail: ['结汇下发 - 详情','settle&disb-details'],
    globalCollection: ['全球收款','Global Collection'],
    receivingSettlementRecord: ['企业汇款人备案','Corporate Rem-fil'],
    info: ['账户信息','acct info'],
    details: ['账户信息详情','acct info details'],
    account: ['VA账号申请','VA acct application.'],
    apply: ['申请VA账号','apply for VA acct'],
    list: ['VA账号列表','VA acct list'],
    collectionRecord: ['VA收款记录','VA coll Records'],
    issuedOverseaList: ['海外下发','Ovrseas Disb'],
    reconciliation: ['对账文件','Recon file'],
    domesticPaid: ['国内批量代付','domestic paid'],
    domesticPaidDetail: ['国内批量代付 - 详情','domestic paid-detail'],
    virtualCard: ['数字卡','Virtual Card'],
    denomination: ['卡面额管理列表','card denom mgt list'],
    cardRecharge: ['数字卡充值','card recharge'],
    cardApply: ['数字卡创建','card creation'],
    cardDetails: ['数字卡详情','card details'],
    virtualCardManagement: ['卡片管理','virtual card mgt'],
    applyMulti: ['创建多币种数字卡','create multi-curr card'],
    multiVirtualCard: ['多币种卡片管理','multi-curr card mgt'],
    multiDenomination: ['多币种卡面额管理','multi-curr card denom mgt'],
    multiDetails: ['多币种卡详情','multi-curr card details'],
    overseasReceipt: ['境外收单','overseas Receipt'],
    settlement: ['结算明细','settlement details'],
    orderList: ['订单明细','order details'],
    overseasRefund: ['退款明细','refund details'],
    dispute: ['争议明细','dispute details'],
    permission: ['业务权限浏览','Business Pmn'],
    bankRecord: ['银行备案信息','Bank Filing Info.'],
    setting: ['用户设置','User Settings'],
}
